import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import ChallengeView from './ChallengeView';
import { answerText } from './registry';
import { stepText } from './stepText';

// A solved challenge: the challenge with its highlights, the expected answer written in clear, and the steps
// of the engine ("why"). Used by the examples and by the verdict of the exercise.
export const SolutionView = ({ item, solution, blockSizes, answerLabelId, intl }) => {
    const answer = answerText(solution);
    const steps = (solution && Array.isArray(solution.steps) ? solution.steps : [])
        .map((step) => stepText(step, intl.formatMessage))
        .filter(Boolean);
    return (
        <div className="hia-ack-solution">
            <ChallengeView item={item} highlights={solution && solution.highlights} blockSizes={blockSizes} />
            {answer !== null && answer !== '' && (
                <p className="hia-ack-answer-line">
                    <FormattedMessage id={answerLabelId || 'conventionPage.examples.answer'} />{' '}
                    <b className="hia-ack-answer" data-testid="solution-answer">{answer}</b>
                </p>
            )}
            {steps.length > 0 && (
                <ul className="hia-ack-steps">
                    {steps.map((text, index) => <li key={index}>{text}</li>)}
                </ul>
            )}
        </div>
    );
};

export default injectIntl(SolutionView);
